<template>
<div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; width: 100%">
  <div class="content">
    <Logo/>
    <div class="container">
      <div v-if="success" class="success-icon">✔</div>
      <div v-else class="error-icon">❌</div>
      <h1 class="title" v-html="headerMessage"></h1>
      <p class="booking-ref" v-html="subHeaderMessage1"></p>
      <p class="confirmation-message" v-html="subHeaderMessage2"></p>
      <div class="details" v-html="details">
      </div>
      <div style="display: flex; justify-content: center">
        <button @click="navigateHome" class="action-button">Home</button>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>

<script>
import Logo from "./components/Logo";
import Footer from "./components/Footer";

export default {
  components: {
    Logo,
    Footer
  },
  data() {
    return {
      success: false,
      headerMessage: '',
      subHeaderMessage1: '',
      subHeaderMessage2: '',
      details: ''
    };
  },
  computed: {
    submissionDate() {
      const now = new Date();
      return now.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
    }
  },
  mounted() {
    this.success = window.history.state.success;
    if (this.success) {
      this.headerMessage = window.history.state.headerMessage;
      this.subHeaderMessage1 = window.history.state.subHeaderMessage1;
      this.subHeaderMessage2 = window.history.state.subHeaderMessage2;
      this.details = window.history.state.details;
    } else {
      this.headerMessage = 'Oops! Something went wrong';
      this.subHeaderMessage1 = 'We were unable to process your request';
      this.subHeaderMessage2 = 'Please try again later or contact: </br><strong>wealthlendingnetwork@broadridge.com</strong>';
      this.details = `<p>Requested: ${this.submissionDate}</p>`;
    }
  },
  methods: {
    navigateHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>

.success-icon {
  font-size: 50px;
  color: #001F5A;
  margin-bottom: 15px;
}

.error-icon {
  font-size: 50px;
  margin-bottom: 15px;
}

</style>
